import React from 'react'
import { Link } from 'react-router-dom'
import { ENABLE_USER_BILLING } from '../../config/featureFlags'
import { featureBillingBlockMessage, featureBillingQuotaLabel } from '../../lib/featureBillingGate'

function shouldShowUpgradeLink(gate) {
  return ENABLE_USER_BILLING && (
    gate?.reason === 'SUBSCRIPTION_REQUIRED'
    || gate?.reason === 'SUBSCRIPTION_EXPIRED'
    || gate?.reason === 'QUOTA_EXCEEDED'
    || gate?.reason === 'FEATURE_NOT_ENABLED'
  )
}

/**
 * @param {{
 *   gate: import('../../lib/featureBillingGate').FeatureBillingGate|null|undefined,
 *   quotaLabel?: string,
 *   className?: string,
 * }} props
 */
export default function FeatureGateNotice({ gate, quotaLabel = '조회 가능 건수', className = '' }) {
  const blockMessage = featureBillingBlockMessage(gate)
  const quotaText = featureBillingQuotaLabel(gate)

  return (
    <div className={`space-y-2 ${className}`.trim()}>
      <div className="flex items-center justify-between rounded-lg border border-slate-100 bg-slate-50 px-3 py-2 text-sm">
        <span className="font-medium text-slate-700">{quotaLabel}</span>
        <span className="font-mono text-slate-900">{quotaText}</span>
      </div>
      {blockMessage ? (
        <div className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900">
          <p>{blockMessage}</p>
          {shouldShowUpgradeLink(gate) ? (
            <Link to="/billing/subscribe" className="mt-1 inline-block text-sm font-medium text-brand-navy hover:underline">
              플랜 업그레이드
            </Link>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}